/* ============================================================
   SARTE LEATHER — pdp-enhance.js
   Real Buy-it-now, per-variant SKU / colour / stock / WhatsApp sync.
   ============================================================ */
(function () {
  'use strict';
  var root = document.querySelector('[data-pdp]');
  if (!root) return;

  var $ = function (s, c) { return (c || root).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); };
  var key = function (v) { return String(v || '').trim().toLowerCase(); };

  var pData, sData = {};
  try { pData = JSON.parse($('[data-product-json]').textContent); } catch (e) { return; }
  try { sData = JSON.parse($('[data-pdp-stock-json]').textContent); } catch (e) { sData = {}; }

  function currentVariant() {
    var inputs = $$('[data-option-input]');
    if (!inputs.length) {
      var id = ($('[data-variant-id-input]') || {}).value;
      return pData.variants.filter(function (v) { return String(v.id) === String(id); })[0] || null;
    }
    var sel = pData.options.map(function (n) {
      var i = inputs.filter(function (x) { return key(x.getAttribute('data-option-input')) === key(n) && x.checked; })[0];
      return i ? i.value : null;
    });
    return pData.variants.filter(function (v) {
      return v.options.every(function (o, i) { return o === sel[i]; });
    })[0] || null;
  }

  var colorIdx = -1;
  pData.options.forEach(function (n, i) { if (colorIdx < 0 && /colou?r/i.test(String(n))) colorIdx = i; });

  function sync() {
    var v = currentVariant();
    if (!v) return;

    $$('[data-pdp-sku]').forEach(function (el) {
      el.textContent = v.sku || '';
      var row = el.closest('div');
      if (row) row.style.display = v.sku ? '' : 'none';
    });

    if (colorIdx > -1) {
      $$('[data-pdp-spec-color]').forEach(function (el) { el.textContent = v.options[colorIdx]; });
    }

    var priceRow = $('[data-pdp-price-row]');
    if (priceRow) {
      priceRow.classList.add('is-updating');
      setTimeout(function () { priceRow.classList.remove('is-updating'); }, 220);
    }

    var s = sData[v.id];
    var urgency = $('[data-pdp-stock-urgency]');
    if (urgency) {
      var th = Number(urgency.getAttribute('data-low-stock')) || 5;
      var show = !!(s && s.a && s.m && s.q > 0 && s.q <= th);
      urgency.classList.toggle('is-hidden', !show);
      if (show) {
        var q = $('[data-pdp-stock-qty]', urgency);
        var p = $('[data-pdp-stock-plural]', urgency);
        if (q) q.textContent = s.q;
        if (p) p.textContent = s.q === 1 ? '' : 's';
      }
    }

    var qty = $('[data-pdp-qty]');
    if (qty) {
      if (s && s.m && s.q > 0) qty.max = s.q; else qty.removeAttribute('max');
      if (qty.max && Number(qty.value) > Number(qty.max)) qty.value = qty.max;
    }

    var buy = $('[data-buy-now]');
    if (buy && !buy.classList.contains('is-loading')) buy.disabled = !v.available;

    var wa = $('[data-pdp-whatsapp]');
    if (wa) {
      var num = wa.getAttribute('data-wa-number');
      var txt = 'Hi Sarte Leather, I am interested in ' + pData.title +
        (v.title && v.title !== 'Default Title' ? ' (' + v.title + ')' : '') + ' ' + location.origin + location.pathname;
      wa.href = 'https://wa.me/' + num + '?text=' + encodeURIComponent(txt);
    }
  }

  $$('[data-option-input]').forEach(function (i) {
    i.addEventListener('change', function () { setTimeout(sync, 0); });
  });
  sync();

  /* ---------- Buy it now: add to cart, then straight to checkout ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-buy-now]') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.disabled || btn.classList.contains('is-loading')) return;

    var form = btn.closest('form');
    if (!form) return;
    var idEl = $('[data-variant-id-input]', form);
    var qtyEl = $('[data-pdp-qty]', form);
    var id = idEl ? Number(idEl.value) : 0;
    var q = qtyEl ? parseInt(qtyEl.value, 10) || 1 : 1;
    if (!id) return;

    var fb = $('[data-pdp-atc-feedback]');
    btn.classList.add('is-loading');
    btn.disabled = true;

    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: q }] })
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw j; return j; });
    }).then(function () {
      window.location.href = '/checkout';
    }).catch(function (err) {
      btn.classList.remove('is-loading');
      btn.disabled = false;
      if (fb) fb.textContent = (err && (err.description || err.message)) || 'Could not start checkout. Please try again.';
    });
  }, true);
})();
